const env = process.env.NODE_ENV
const name = process.env.VUE_APP_NAME
const apiURL = process.env.VUE_APP_API_URL
console.log('env', env, 'name', name, 'baseURL', apiURL)
function getDifAddress (name) {
  if (typeof apiURL === 'string' && apiURL.startsWith('http')) {
    return apiURL
  }
  let apiUrl = null
  switch (name) {
    case 'default':
      apiUrl = env === 'production' ? 'https://singapore.fooyotravel.com/' : 'https://singapore-staging.fooyotravel.com/'
      break
    case 'wholesale':
      apiUrl = env === 'production' ? 'https://fulai-api.neutronapi.run/' : 'https://fulai-api.neutronapi.run/'
      break
    case 'fooyo':
      apiUrl = env === 'production' ? 'https://singapore.fooyotravel.com/' : 'https://singapore-staging.fooyotravel.com/'
      break
    case 'zoo':
      apiUrl = env === 'production' ? 'https://singapore-zoo.fooyotravel.com/' : 'https://minishop-staging.neutron.sg/'
      break
    case 'wholesale_fulai':
      apiUrl = env === 'production' ? 'https://fulai-api.neutronapi.run/' : 'https://fulai-uat-api.neutronapi.run/'
      break
    case 'tiny_toes':
      apiUrl = env === 'production' ? 'https://neucommerce.neutronapi.run/' : 'https://neucommerce.neutronapi.run/'
      break
    default:
      apiUrl = 'http://localhost:3000'
      break
  }
  return apiUrl
}
const apiUrl = getDifAddress(name)
export default apiUrl
